import { StyleSheet } from 'react-native';
import { theme } from '@sweetgreen/garnish';

const SHADOW_OFFSET = -6; // Per-design, move shadow higher up.

export const styles = StyleSheet.create({
  contentContainer: {
    height: '100%',
  },
  desktopScreenContainer: {
    flexDirection: 'row',
    height: '100%',
    backgroundColor: theme.colors.OATMEAL,
  },
  mobileScreenContainer: {
    height: '100%',
    overflow: 'hidden',
    backgroundColor: theme.colors.OATMEAL,
    position: 'relative',
  },
  mapContainer: {
    position: 'relative',
    flex: 1,
    backgroundColor: theme.colors.OATMEAL,
  },
  shadowContainer: {
    position: 'absolute',
    top: SHADOW_OFFSET,
    right: 0,
    left: 0,
    zIndex: theme.zIndex.fixed,
  },
  locationContainer: {
    width: 376,
    borderLeftColor: theme.colors.NEUTRAL_1,
    borderLeftWidth: 1,
  },
  mobileSearchContainer: {
    backgroundColor: theme.colors.OATMEAL,
    zIndex: theme.zIndex.fixed,
  },
  desktopLocationResultsContainer: {
    padding: theme.spacing.medium,
  },
  desktopErrorPlaceholder: {
    alignItems: 'center',
    textAlign: 'center',
    paddingVertical: theme.spacing.xlarge,
    paddingHorizontal: theme.spacing.large,
  },
  desktopErrorPlaceholderImage: {
    width: 248,
    height: 248,
    resizeMode: 'contain',
  },
  enableLocationServiceText: {
    paddingTop: theme.spacing.large,
  },
});
